import { colors, fontSizes } from "@/app/constants/styles";
import { StyleSheet } from "react-native";

export const orderDetailsStyles = StyleSheet.create({
  container: {
    minWidth: 600,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: colors.maroon,
    paddingBottom: 10,
    backgroundColor: colors.white,
    maxHeight: "90%",
  },
  buttonRow: {
    justifyContent: "flex-end",
    marginTop: 15,
  },
  buttonContainer: {
    justifyContent: "space-between",
    flexDirection: "row",
  },
  confirmOrderHeader: {
    fontSize: fontSizes.x20,
    fontFamily: "HelveticaNeue-Medium",
    color: colors.white,
    textAlign: "center",
    marginBottom: 10,
  },
  confirmOrderContainer: {
    width: "55%",
  },
  confirmOrderText: {
    fontSize: fontSizes.x10,
    fontFamily: "HelveticaNeue",
    color: colors.white,
    textAlign: "center",
    marginBottom: 15,
  },
  editOrderContainer: {
    width: "40%",
  },
  editOrderButton: {
    alignItems: "center",
    height: 50,
    borderRadius: 8,
    borderColor: colors.white,
    borderWidth: 1,
    justifyContent: "center",
  },
  editOrder: {
    fontSize: fontSizes.x12,
    fontFamily: "HelveticaNeue",
    color: colors.white,
  },
});

export const headerStyles = StyleSheet.create({
  container: {
    paddingHorizontal: 10,
    paddingVertical: 15,
    borderTopStartRadius: 10,
    borderTopEndRadius: 10,
    backgroundColor: colors.separatorGray(),
  },
  rowContainer: {
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  timeText: {
    fontSize: fontSizes.x10,
    fontFamily: "HelveticaNeue",
    color: colors.maroon,
    textAlign: "center",
    opacity: 0.5,
  },
  rowBoldText: {
    fontSize: fontSizes.x12,
    fontFamily: "HelveticaNeue",
    color: colors.maroon,
    opacity: 0.6,
    marginVertical: 10,
  },
  rowText: {
    fontSize: fontSizes.x10,
    fontFamily: "HelveticaNeue-Medium",
    color: colors.maroon,
    marginBottom: 5,
  },
});

export const linesStyles = StyleSheet.create({
  container: {
    marginVertical: 20,
  },
  orderLinesContainer: {
    flex: 1,
    paddingTop: 20,
    paddingBottom: 10,
  },
  orderItemsContainer: {
    flexDirection: "row",
    marginBottom: 15,
    marginHorizontal: 20,
    alignItems: "flex-start",
    justifyContent: "space-around",
  },
  orderItemsQuantityContainer: {
    flex: 1,
    alignItems: "flex-start",
  },
  orderItemsTitleContainer: {
    flex: 4,
  },
  orderItemsPriceContainer: {
    flex: 1,
    alignItems: "flex-end",
  },
  itemHeader: {
    fontSize: fontSizes.x10,
    fontFamily: "HelveticaNeue",
    color: colors.maroon,
  },
  itemPrice: {
    color: colors.albaikRed,
    fontSize: fontSizes.x10,
    fontFamily: "HelveticaNeue",
  },
  itemChoice: {
    fontSize: fontSizes.x8,
    fontFamily: "HelveticaNeue",
    color: colors.maroon,
    marginLeft: 25,
  },
});

export const reprintButtonStyles = StyleSheet.create({
  reprintButtonContainer: {
    marginHorizontal: 10,
  },
  reprintButtonButton: {
    alignItems: "center",
    height: 50,
    borderRadius: 8,
    backgroundColor: colors.albaikBrightRed,
    justifyContent: "center",
  },
  reprintButton: {
    fontSize: fontSizes.x12,
    fontFamily: "HelveticaNeue",
    color: colors.white,
  },
});
